import { makeAutoObservable } from "mobx";
import { Salary } from "../api/SalaryApiClient";
import ApiStore from "./ApiStore";

class SalaryStore {
  isLoading: boolean = true;
  ApiStore!: ApiStore;
  salaries: Salary[];
  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.ApiStore = apiStore;
    this.salaries = [];
  }
  add = async (salary: any) => {
    this.isLoading = true;
    const response = await this.ApiStore.SalaryApiClient.addSalary(salary);
    this.isLoading = false;
    return response;
  };
  getAll = async () => {
    this.isLoading = true;
    const result = await this.ApiStore.SalaryApiClient.getAll()
      .then((res) => {
        this.salaries = res;
        return res;
      })
      .finally(() => {
        this.isLoading = false;
      });
    return result;
  };
  getByPeriod = async (startDate: any, endDate: any) => {
    this.isLoading = true;
    const result = await this.ApiStore.SalaryApiClient.salariesByPeriod(
      startDate,
      endDate
    )
      .then((res) => {
        this.salaries = res;
        return res;
      })
      .finally(() => {
        this.isLoading = false;
      });
    return result;
  };
}
export default SalaryStore;
